const Pagenotfound = () => {
    return ( 
        <div>
            Page Not Found
        </div>
     );
}
 
export default Pagenotfound;